import Statistics from "./statistics";

class Portfolio {
  constructor() {
    this.positions = undefined;
    this.returns = undefined;
    this.benchmarkReturns = undefined;
    this.targetPositions = undefined;
  }

  setPositions(positions) {
    this.positions = positions;
  }

  setReturns(returns) {
    this.returns = returns;
  }

  setTargetPositions(targetPositions){
    this.targetPositions = targetPositions; 
  }

  setBenchmarkReturns(benchmarkReturns) {
    this.benchmarkReturns = benchmarkReturns;
  }

  quotas() {
    if (!this.returns) {
      throw new Error("Portfolio returns must be set to calculate quotas!");
    }

    return Statistics.quotasSeries(this.returns);
  }

  benchmarkQuotas() {
    if (!this.benchmarkReturns) {
      throw new Error(
        "Portfolio benchmark returns must be set to calculate benchmark quotas"
      );
    }

    return Statistics.quotasSeries(this.benchmarkReturns);
  }

  cagr() {
    if (!this.returns) {
      throw new Error("Portfolio returns must be set to calculate CAGR!");
    }

    return Statistics.cagr(this.returns);
  }

  sharpe() {
    if (!this.benchmarkReturns) {
      throw new Error("Benchmark returns must be set to calculate sharpe!");
    }

    if (!this.returns) {
      throw new Error("Portfolio returns must be set to calculate sharpe!");
    }

    return Statistics.sharpe(this.returns, this.benchmarkReturns);
  }

  volatility() {
    if (!this.returns) {
      throw new Error("Portfolio returns must be set to calculate volatility!");
    }
    return Statistics.volp(this.returns);
  }

  maxDrawdown() {
    if (!this.returns) {
      throw new Error(
        "Portfolio returns must be set to calculate max. drawdown!"
      );
    }

    return Statistics.maxDrawdown(this.returns);
  }

  returnMTD() {
    if (!this.returns) {
      throw new Error("Portfolio returns must be set to calculate return MTD");
    }

    return Statistics.returnMTD(this.returns);
  }

  returnYTD() {
    if (!this.returns) {
      throw new Error("Portfolio returns must be set to calculate return YTD");
    }

    return Statistics.returnYTD(this.returns);
  }

  return3M() {
    if (!this.returns) {
      throw new Error("Portfolio returns must be set to calculate return 3M");
    }

    return Statistics.return3M(this.returns);
  }

  return6M() {
    if (!this.returns) {
      throw new Error("Portfolio returns must be set to calculate return 6M");
    }

    return Statistics.return6M(this.returns);
  }

  return12M() {
    if (!this.returns) {
      throw new Error("Portfolio returns must be set to calculate return123M");
    }

    return Statistics.return12M(this.returns);
  }

  returnSI() {
    if (!this.returns) {
      throw new Error("Portfolio returns must be set to calculate return SI");
    }

    return Statistics.returnSI(this.returns);
  }
}

export default Portfolio;
